<mat-tab-group #paymentModetabGroup (selectedTabChange)="onTabChanged($event)" [selectedIndex]="selectedIndex">

    <mat-tab class="payment-mode">
        <ng-template mat-tab-label>
            <div class="row">
                <div class="row">
                    <img class="tab-logo" *ngIf="paymentModetabGroup.selectedIndex === 0"
                        src="./../../assets/images/payment-collection/saved-payments-active.svg" />
                    <img class="tab-logo" *ngIf="paymentModetabGroup.selectedIndex != 0"
                        src="./../../assets/images/payment-collection/saved-payments.svg" />
                </div>
                <div class="headline-1">
                    <span> SAVED </span>
                    <span> PAYMENT </span>
                </div>
            </div>
        </ng-template>
        <app-payment-mode-saved-payment (isFormInstanceCreated)="onFormInstanceCreated(0, $event)"
            [paymentRequest]="paymentRequest"></app-payment-mode-saved-payment>
    </mat-tab>

    <mat-tab class="payment-mode">
        <ng-template mat-tab-label>
            <div class="row">
                <img class="tab-logo" *ngIf="paymentModetabGroup.selectedIndex === 1"
                    src="./../../assets/images/payment-collection/debit-card-payments-active.svg"
                    style="margin-top:10px" />
                <img class="tab-logo" *ngIf="paymentModetabGroup.selectedIndex != 1"
                    src="./../../assets/images/payment-collection/debit-card-payments.svg" style="margin-top:10px" />
                <div class="headline-1">
                    <span> DEBIT </span>
                    <span> CARD </span>
                </div>
                <div class="upi-fee">
                    <span> Convenience </span>
                    <span> fee applicable </span>
                </div>
            </div>
        </ng-template>
        <app-payment-mode-debit-card (isFormInstanceCreated)="onFormInstanceCreated(1, $event)"
            [paymentRequest]="paymentRequest"></app-payment-mode-debit-card>
    </mat-tab>

    <mat-tab class="payment-mode">
        <ng-template mat-tab-label>
            <div class="row">
                <div class="row">
                    <img class="tab-logo" *ngIf="paymentModetabGroup.selectedIndex === 2"
                        src="./../../assets/images/payment-collection/net-banking-active.svg" />
                    <img class="tab-logo" *ngIf="paymentModetabGroup.selectedIndex != 2"
                        src="./../../assets/images/payment-collection/net-banking.svg" />
                </div>
                <div class="headline-1">
                    <span> NET </span>
                    <span> BANKING </span>
                </div>
                <div class="upi-fee">
                    <span> Convenience </span>
                    <span> fee applicable </span>
                </div>
            </div>
        </ng-template>
        <app-payment-mode-net-banking (isFormInstanceCreated)="onFormInstanceCreated(2, $event)"
            [paymentRequest]="paymentRequest"></app-payment-mode-net-banking>
    </mat-tab>

    <mat-tab class="payment-mode">
        <ng-template mat-tab-label>
            <div class="row">
                <div class="row">
                    <img class="tab-logo" *ngIf="paymentModetabGroup.selectedIndex === 3"
                        src="./../../assets/images/payment-collection/upi-payments-active.svg" />
                    <img class="tab-logo" *ngIf="paymentModetabGroup.selectedIndex != 3"
                        src="./../../assets/images/payment-collection/upi-payments.svg" />
                </div>
                <div class="headline-1">
                    <span> UPI </span>
                    <span> PAYMENT </span>
                </div>
                <div class="upi-fee" [class.color-upi]="paymentModetabGroup.selectedIndex != 3">
                    <span> Zero </span>
                    <span> convenience fee </span>
                </div>
            </div>
        </ng-template>
        <app-payment-mode-upi-payment (isFormInstanceCreated)="onFormInstanceCreated(3, $event)"
            [paymentRequest]="paymentRequest"></app-payment-mode-upi-payment>
    </mat-tab>
</mat-tab-group>